const businessmagadd = {
  path: 'businessmagadd',
  component: resolve => require(['@/pages/admin/businessmag/add'], resolve),
  meta: {
    requireAuth: true
  }
}

export default businessmagadd
